import { Link } from 'react-router-dom';
export default function AdminMenuStatic() {
  return (
    <div className="admin-menu px-2">
      <div className="accordion" id="adminMenuAccordion">
        {/* FORMALITES */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingFormalites">
            <button
              className="accordion-button collapsed decoration-on-hover"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFormalites"
            >
              Formalités
            </button>
          </h2>
          <div
            id="collapseFormalites"
            className="accordion-collapse collapse"
            data-bs-parent="#adminMenuAccordion"
          >
            <div className="accordion-body p-0">
              <ul className="list-unstyled m-0">
                <li className="py-2 px-3">
                  <Link to="/admin/formalities/requests/list" className="decoration-on-hover">Demandes de formalités</Link>
                </li>
                <li className="py-2 px-3">
                  <Link to="/admin/formalities/templates/categories" className="decoration-on-hover">Catégories de formalités</Link>
                </li>
                <li className="py-2 px-3">
                  <Link to="/admin/formalities/templates/list" className="decoration-on-hover">Catalogue de formalités</Link>
                </li>
                <li className="py-2 px-3">
                  <Link to="/admin/formalities/pricings" className="decoration-on-hover">Tarifs des formalités</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* COMMANDES */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingCommandes">

            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseCommandes"
            >
              Commandes
            </button>
          </h2>
          <div
            id="collapseCommandes"
            className="accordion-collapse collapse"
            data-bs-parent="#adminMenuAccordion"
          >
            <div className="accordion-body p-0">
              <ul className="list-unstyled m-0">
                <li className="py-2 px-3">


                  <Link to="/admin/orders" className="decoration-on-hover">Liste des commandes</Link>
                </li>

                <li className="py-2 px-3"><s>Export des ventes</s></li>
              </ul>
            </div>
          </div>
        </div>
        {/* CLIENTS */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingClients">
            <button
              className="accordion-button collapsed text-muted"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseClients"

            >
              Clients
            </button>
          </h2>
          <div
            id="collapseClients"
            className="accordion-collapse collapse"
            data-bs-parent="#adminMenuAccordion"
          >
            <div className="accordion-body p-0">
              <ul className="list-unstyled m-0">
                <li className="py-2 px-3">
                  <Link to="/admin/customers" className="decoration-on-hover">Liste des clients</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* ADMIN */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingAdmin">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseAdmin"
            >
              Admin
            </button>
          </h2>
          <div
            id="collapseAdmin"
            className="accordion-collapse collapse"
            data-bs-parent="#adminMenuAccordion"
          >
            <div className="accordion-body p-0">
              <ul className="list-unstyled m-0">
                <li className="py-2 px-3"><a href="#" className="text-decoration-none">
                  <Link to="/admin/admin/parameters" className="decoration-on-hover">Paramètres</Link>
                </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}